export default {
    REFUSE_REASON_2: {
        // 箱损
        10: [{
            value: '1723',
            label: '外包装破损，消费者拒收'
        }],
        // 无理由拒收
        11: [{
            value: '1005',
            label: '外包装完好，现场未开箱，用户无理由拒收'
        },
        {
            value: '1006',
            label: '外包装完好，现场已开箱，内机、附件完好，用户无理由拒收'
        }],
        // 配送延迟
        13: [{
            value: '1505',
            label: '因极端恶劣天气、自然灾害、政府限行等不可抗力，消费者拒收'
        },
        {
            value: '1703',
            label: '物流原因配送延迟，消费者拒收，消费者拒收'
        }],
        // 配送串货
        15: [{
            value: '1704',
            label: '订单与实际送的货物不相符，导致的消费者拒收，消费者拒收'
        }],
        // 内外商品不符
        16: [{
            value: '1719',
            label: '外包装完好，开箱后内外商品不相符，消费者拒收'
        },
        {
            value: '1720',
            label: '外包装破损，开箱后内外商品不相符，消费者拒收'
        }],
        // 内商品少附件/短少
        17: [{
            value: '1702',
            label: '外包装完好，开箱后发现内商品少附件/短少，消费者拒收'
        },
        {
            value: '1721',
            label: '外包装破损，开箱后发现内商品少附件/短少，消费者拒收'
        }],
        // 机损
        19: [{
            value: '1724',
            label: '外包装完好，外屏碎，消费者拒收'
        },
        {
            value: '1725',
            label: '外包装完好，内屏碎，消费者拒收'
        },
        {
            value: '1712',
            label: '外包装完好，内机墩角、裂痕、凹痕，消费者拒收'
        },
        {
            value: '1713',
            label: '外包装完好，内机异常，影响使用，消费者拒收'
        },
        {
            value: '1714',
            label: '物流原因致使的商品破损，消费者拒收'
        },
        {
            value: '1715',
            label: '外包装破损，外屏碎，消费者拒收'
        },
        {
            value: '1716',
            label: '外包装破损，内屏碎，消费者拒收'
        },
        {
            value: '1717',
            label: '外包装破损，内机墩角、裂痕、凹痕，消费者拒收'
        },
        {
            value: '1718',
            label: '外包装破损，内机异常，影响使用，消费者拒收'
        }],
        // 地址错误
        23: [{
            value: '1034',
            label: '因用户地址错误，导致的消费者拒收'
        }],
        // 大件无法进门
        24: [{
            value: '1706',
            label: '商品尺寸过大，无法送货入户，消费者拒收'
        }],
        // 安得原因
        25: [{
            value: '1707',
            label: '物流原因配送延迟，消费者拒收'
        },
        {
            value: '1708',
            label: '安得未到货'
        },
        {
            value: '1709',
            label: '上游拦截失败'
        },
        {
            value: '1710',
            label: '物流到货破损、用户拒收'
        }],
        // 不可抗力原因
        26: [{
            value: '1711',
            label: '因极端恶劣天气、自然灾害、政府限行等不可抗力，消费者拒收'
        }]
    }
};